import Color from 'color';
import { calcAPCA } from 'apca-w3';

function getAccessibleTextColor(backgroundColor: string) {
  const blackL = Math.abs(calcAPCA('#000', backgroundColor));
  const whiteL = Math.abs(calcAPCA('#fff', backgroundColor));
  return blackL > whiteL ? '#000' : '#fff';
}

export default function useColor() {
  const setColors = (primaryColor: string, secondaryColor: string) => {
    const primary = Color(primaryColor);
    const secondary = Color(secondaryColor);
    const docStyle = document.documentElement.style;
    docStyle.setProperty('--el-color-primary', secondary.hex());
    docStyle.setProperty('--primary-color', primary.hex());
    docStyle.setProperty('--primary-color-dark', primary.darken(0.2).hex());
    docStyle.setProperty('--secondary-color', secondary.hex());
    docStyle.setProperty('--secondary-color-dark', secondary.darken(0.2).hex());
    const primaryText = getAccessibleTextColor(primary.hex());
    const secondaryText = getAccessibleTextColor(secondary.hex());
    const primaryDarkText = getAccessibleTextColor(primary.darken(0.2).hex());
    const secondaryDarkText = getAccessibleTextColor(
      secondary.darken(0.2).hex(),
    );
    docStyle.setProperty('--primary-text-color', primaryText);
    docStyle.setProperty('--primary-dark-text-color', primaryDarkText);
    docStyle.setProperty('--secondary-text-color', secondaryText);
    docStyle.setProperty('--secondary-dark-text-color', secondaryDarkText);
  };

  return { setColors };
}
